import { getDygcAllUser as apiGetDygcUser } from '@/api/wenjuan/user'

export const userHash = new Map()
let companyUser = null

function initDept(data = [], flag = false) {
  let results = []
  for (let i = 0, len = data.length; i < len; i++) {
    //获取企业id 短信使用审批需使用此字段
    let companyId = data[0].id
    let { organizationVOs, staffs, name, id, customerId } = data[i]
    let result = {
      name,
      id,
      customerId,
      flag,
      companyId
    }
    if (userHash.has(id)) continue
    let children = []
    if (organizationVOs && organizationVOs.length) {
      result.hasChild = true
      children.push(...initDept(organizationVOs))
    }
    if (staffs && staffs.length) {
      result.hasChild = true
      children.push(...initDept(staffs, true))
    }
    result.children = children
    if (result.children && result.children.length) {
      result.disabled = result.children.every(item => item.disabled)
    }
    // else
    // result.disabled = !!this.selectList.find(item => item.id === id)
    userHash.set(result.id, result)
    results.push(result)
  }
  return results
}

export function initDygcUser(companyUser) {
  userHash.clear()
  return initDept([companyUser])
}

export function getDygcAllUser() {
  return new Promise((resolve, reject) => {
    if (companyUser) {
      resolve(companyUser)
      return
    }
    apiGetDygcUser().then(res => {
      resolve(res)
      companyUser = res
    })
  })
}

export function adoptKeyToUserId(keys = []) {
  let results = []
  keys.forEach(key => {
    if (userHash.has(key)) {
      let item = userHash.get(key)
      if (item.flag && !results.some(i => i.id === item.id)) {
        results.push(item)
      }
    }
  })
  return results
}

function getNodeUser(node) {
  let results = []
  for (let i = 0, len = node.children.length; i < len; i++) {
    let child = node.children[i]
    if (child.flag) {
      results.push(child)
    } else {
      results.push(...getNodeUser(child))
    }
  }
  return results
}

export function getCurrentTreeUserNode(node, selects = []) {
  let users = getNodeUser(node)
  let keys = users.map(item => item.id)
  keys = keys.filter(key => {
    return selects.includes(key)
  })
  return keys
}
